import { html } from 'lit';

export const dropdownIndicatorIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M7 10l5 5 5-5z" />
  </svg>
`;